export const OLT_BRAND = [
  {
    code: "Huawei",
    name: "Huawei",
    types: [
      { type: "MA5800", name: "MA5800" },
      { type: "MA5801", name: "MA5801" },
    ],
  },
  {
    code: "ZTE",
    name: "ZTE",
    types: [
      { type: "C600", name: "C600" },
      { type: "C300", name: "C300" },
    ],
  },
];

export const OLT_TYPE = [
  { type: "C600", name: "C600" },
  { type: "C300", name: "C300" },
  { type: "MA5800", name: "MA5800" },
];
